// apps/web/src/pages/admin/reservations/reservations-operations.ts — Phase 5 plan 05-04.

import { gql } from "graphql-request";

export const RESERVATIONS_PAGINATED_QUERY = gql`
  query ReservationsPaginated(
    $filter: ReservationFilter
    $cursor: String
    $limit: Int!
  ) {
    reservations(filter: $filter, cursor: $cursor, limit: $limit) {
      items {
        id
        reservationNumber
        status
        source
        startsAt
        durationMinutes
        partySize
        guestName
        guestEmail
        guestPhone
        internalNote
        slotDefinitionId
        serviceDate
      }
      nextCursor
    }
  }
`;

export const RESERVATION_CANCEL_MUTATION = gql`
  mutation CancelReservationAdmin($id: ID!, $reason: String) {
    cancelReservationByAdmin(id: $id, reason: $reason) {
      id
      status
      cancelledAt
    }
  }
`;

export const RESERVATION_SET_STATUS_MUTATION = gql`
  mutation SetStatusAdmin($id: ID!, $status: ReservationStatus!) {
    setReservationStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;

// Quick 260831-q3h: per-status inline buttons on the Reservations page
// (Bestätigen / Angekommen / No-Show) need dedicated mutations so the
// server-side audit row carries the right action marker (the catch-all
// `setReservationStatus` writes a generic ReservationStatusChanged row
// without the dedicated marker that `markArrived` / `markNoShow` write).
export const RESERVATION_MARK_ARRIVED_MUTATION = gql`
  mutation MarkArrivedAdmin($id: ID!) {
    markArrived(id: $id) {
      id
      status
      markedArrivedAt
    }
  }
`;

export const RESERVATION_MARK_NO_SHOW_MUTATION = gql`
  mutation MarkNoShowAdmin($id: ID!) {
    markNoShow(id: $id) {
      id
      status
      markedNoShowAt
    }
  }
`;

export const RESERVATION_QUERY = gql`
  query ReservationAdmin($id: ID!) {
    reservation(id: $id) {
      id
      reservationNumber
      status
      source
      startsAt
      durationMinutes
      partySize
      guestName
      guestEmail
      guestPhone
      internalNote
      slotDefinitionId
      serviceDate
    }
  }
`;
